const API_BASE = import.meta.env.VITE_API_BASE_URL || "";

export async function fetchSheetPreview(sheets: string[], limit = 5): Promise<unknown> {
  const params = new URLSearchParams({ sheets: sheets.join(","), limit: String(limit) });
  const response = await fetch(`${API_BASE}/api/sheet-preview?${params.toString()}`);
  const body = await response.json();
  if (!response.ok) {
    throw new Error(body?.error ?? `Request failed with ${response.status}`);
  }
  return body;
}

export async function fetchHealth(): Promise<unknown> {
  const response = await fetch(`${API_BASE}/api/health`);
  return response.json();
}
